import { api, ok } from "./api";

/**
 * Uploads a signed contract (a PDF, up to 20 MB) for a price to point at. The API takes a
 * multipart form: the serializer builds it, so the body object only satisfies the types.
 */
export const uploadContract = (file: File) =>
  ok(
    api.POST("/v1/admin/files", {
      body: { purpose: "contract", file: file.name },
      bodySerializer: () => {
        const form = new FormData();
        form.set("purpose", "contract");
        form.set("file", file);
        return form;
      },
    }),
  );

/**
 * Uploads a photo or a signature (an image, up to 10 MB) for a delivery's proof, when staff mark
 * it delivered.
 */
export const uploadProofFile = (file: File, purpose: "delivery_photo" | "signature") =>
  ok(
    api.POST("/v1/admin/files", {
      body: { purpose, file: file.name },
      bodySerializer: () => {
        const form = new FormData();
        form.set("purpose", purpose);
        form.set("file", file);
        return form;
      },
    }),
  );

/** Uploads a photo (an image, up to 10 MB) for a shift checklist answer, when staff open a shift. */
export const uploadShiftPhoto = (file: File) =>
  ok(
    api.POST("/v1/admin/files", {
      body: { purpose: "shift_photo", file: file.name },
      bodySerializer: () => {
        const form = new FormData();
        form.set("purpose", "shift_photo");
        form.set("file", file);
        return form;
      },
    }),
  );

/** Uploads a partner's KRA eTIMS invoice (a PDF, up to 10 MB) for a payout request. */
export const uploadEtimsInvoice = (file: File) =>
  ok(
    api.POST("/v1/admin/files", {
      body: { purpose: "etims_invoice", file: file.name },
      bodySerializer: () => {
        const form = new FormData();
        form.set("purpose", "etims_invoice");
        form.set("file", file);
        return form;
      },
    }),
  );

/** A stored file with a fresh link (it expires in 5 minutes): fetch it when someone opens it. */
export const openFile = async (id: string) => {
  const file = await ok(api.GET("/v1/admin/files/{id}", { params: { path: { id } } }));
  window.open(file.url, "_blank", "noopener");
};
